import React, { ReactNode } from 'react';
import { Icon, IconName, Popover, Center, IconSize, PopoverPlacement, Text, Box } from '@televet/kibble-ui';
import { TypographyVariant } from '@televet/kibble-ui/build/shared/types/typography';

interface InfoIconProps {
  heading?: string;
  text?: string;
  children?: ReactNode;
  placement?: PopoverPlacement;
  iconName?: IconName;
  iconColor?: TypographyVariant;
  iconSize?: IconSize;
}

const PopoverOffsetMap: Partial<Record<PopoverPlacement, [number, number]>> = {
  'bottom-start': [-5, 4],
  'bottom-end': [5, 4],
  'top-start': [-5, 4],
  'top-end': [5, 4],
};

export const InfoIcon = ({
  heading,
  text,
  children,
  placement = 'bottom-start',
  iconName = 'infoCircle',
  iconColor = 'subtle',
  iconSize = 'sm',
}: InfoIconProps): JSX.Element => {
  return (
    <Popover
      size="lg"
      {...(heading && {
        headerProps: {
          children: heading,
        },
      })}
      placement={placement}
      trigger="hover"
      strategy="fixed"
      anchor={
        <Center cursor="pointer" mx={1}>
          <Icon name={iconName} size={iconSize} color={iconColor} />
        </Center>
      }
      offset={PopoverOffsetMap[placement]}
    >
      <Box whiteSpace="initial">
        {text && (
          <Text fontWeight="normal" variant="onContrast" size="sm">
            {text}
          </Text>
        )}
        {children}
      </Box>
    </Popover>
  );
};
